import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listCompanies, getCompanyDetail, listTrash } from '../../api/crmApi';

import { companiesKeys } from './keys';

export const companiesListOptions = (filters = {}) =>
	queryOptions({
		queryKey: companiesKeys.list(filters),
		queryFn: async () => listCompanies(filters),
		staleTime: STALE_TIMES.FREQUENT,
	});

export function useCompaniesList(filters = {}, { enabled = true } = {}) {
	return useQuery({ ...companiesListOptions(filters), enabled });
}

export const companyDetailOptions = (companyId) =>
	queryOptions({
		queryKey: companiesKeys.detail(companyId),
		queryFn: async () => getCompanyDetail(companyId),
		staleTime: STALE_TIMES.FREQUENT,
	});

export function useCompanyDetail(companyId) {
	return useQuery({
		...companyDetailOptions(companyId),
		enabled: Boolean(companyId),
	});
}

export function useTrashList(filters = {}, { enabled = true } = {}) {
	return useQuery({
		queryKey: companiesKeys.trash(filters),
		queryFn: async () => listTrash(filters),
		staleTime: STALE_TIMES.FREQUENT,
		enabled,
	});
}
